module.exports = __webpack_public_path__ + "static/media/press-room.d7fe8ff6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/press-room.jpg
// module id = 1082
// module chunks = 0